import React, { forwardRef, useEffect } from 'react';
import { Col, Row } from 'react-bootstrap';
import { getFullNameUser, numberWithCommas } from '../../Helpers/Utils/Common';

const PrintHourly = forwardRef(( props, ref ) => {
  return (
    <div ref={ref} className='p-2'>
        <Row>
            <Col>
                <Row>
                    <Col>
                        <label>Company Name</label>
                    </Col>
                    <Col className='d-flex justify-content-end'>
                        <strong>{getFullNameUser()}</strong>
                    </Col>
                </Row>
                <Row>
                    <label>Trade Name</label>
                </Row>
                <Row>
                    <label>Address</label>
                </Row>
            </Col>
        </Row>
        {/* to be condition if button clicked is hourly print category sales report else daily or hourly*/}
        <Row>
            <Col className='d-flex justify-content-start mt-3'>
                <h5><strong>Hourly Sales Report</strong></h5>
            </Col>
            <hr/>
        </Row>
        {props.data && props.data.map((item) => (
            <Row className='ms-2'>
                <Col>{item.HourRange}</Col>
                <Col className='d-flex justify-content-end'>{numberWithCommas(item.total_amount)}</Col>
            </Row>
        ))}
        <Row>
            <hr/>
            <Col className='d-flex justify-content-end'>
                <h5><strong>Total Sales : {numberWithCommas(props.data && props.data.length > 0 ? props.data.map((item) => parseFloat(item.total_amount)).reduce((a, b) => a + b, 0).toFixed(2) : "0.00")}</strong></h5>
            </Col>
        </Row>
    </div>
  )
});

export default PrintHourly;